var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-1 m-1 border shadow rounded col-10",
      attrs: { id: "new-crud" },
    },
    [
      _c("form", { on: { submit: _vm.checkForm } }, [
        _vm.errors.length
          ? _c("div", { staticClass: "text-danger" }, [
              _c("b", [_vm._v("Please correct the following error(s):")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.errors, function (error) {
                  return _c("li", [_vm._v(_vm._s(error))])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "form-group col-4" }, [
            _c("label", { attrs: { for: "sectionName" } }, [
              _vm._v("Name Of Section"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newSection.section_name,
                  expression: "newSection.section_name",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "sectionName" },
              domProps: { value: _vm.newSection.section_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newSection, "section_name", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-4" }, [
            _c("label", { attrs: { for: "title" } }, [_vm._v("Title")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newSection.title,
                  expression: "newSection.title",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "title" },
              domProps: { value: _vm.newSection.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newSection, "title", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-4" }, [
            _c("label", { attrs: { for: "singularTitle" } }, [
              _vm._v("Singular Title"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newSection.title_singular,
                  expression: "newSection.title_singular",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "singularTitle" },
              domProps: { value: _vm.newSection.title_singular },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.newSection,
                    "title_singular",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-success waves-effect waves-light text-white",
                on: {
                  click: function ($event) {
                    return _vm.addNewFields()
                  },
                },
              },
              [
                _c("i", { staticClass: "feather icon-plus" }),
                _vm._v(
                  "\n                    Add New Fields\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "new-fields" },
              _vm._l(_vm.newSection.fields, function (field, key) {
                return _c("div", { key: key, staticClass: "d-flex" }, [
                  _c(
                    "div",
                    { staticClass: "form-group mr-1 align-self-center" },
                    [
                      _c("label", { attrs: { for: "newFieldname" } }, [
                        _vm._v("Field Name"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.fld,
                            expression: "field.fld",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "newFieldname" },
                        domProps: { value: field.fld },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(field, "fld", $event.target.value)
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group mr-1 align-self-center" },
                    [
                      _c("label", { attrs: { for: "newFieldText" } }, [
                        _vm._v("Field Text"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.fld_text,
                            expression: "field.fld_text",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "newFieldText" },
                        domProps: { value: field.fld_text },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(field, "fld_text", $event.target.value)
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-group flex-fill mr-1 align-self-center",
                    },
                    [
                      _c("label", { attrs: { for: "newFieldHelper" } }, [
                        _vm._v("Field Helper Text"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.fld_helper,
                            expression: "field.fld_helper",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "newFieldHelper" },
                        domProps: { value: field.fld_helper },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(field, "fld_helper", $event.target.value)
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group pb-05 align-self-end" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pl-05 action-btns ",
                          staticStyle: { width: "60px" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn-sm btn-danger text-white",
                              on: {
                                click: function ($event) {
                                  return _vm.removeField(key)
                                },
                              },
                            },
                            [_vm._v("Delete")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "mt-05 btn btn-primary", attrs: { type: "submit" } },
          [_vm._v("Save")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "btn mt-05 btn-success waves-effect waves-light text-white",
            on: {
              click: function ($event) {
                return _vm.addNewFields()
              },
            },
          },
          [
            _c("i", { staticClass: "feather icon-plus" }),
            _vm._v("\n            Add New Fields\n        "),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }